// REACT IMPORTS
import React from "react";

// PROPS TYPE
interface SupportPhoneLinkProps {
  phone?: string;
  className?: string;
}

/* ------------------------------------- SUPPORT PHONE LINK ------------------------------------- */

// The branding Support Phone, tappable on phones. It is stored the way it is
// shown, for example (404) 410-2799, so ten digits are a US number.
const SupportPhoneLink = ({ phone, className = "" }: SupportPhoneLinkProps) => {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) {
    return <>{phone}</>;
  }

  return (
    <a
      href={`tel:+${digits.length === 10 ? `1${digits}` : digits}`}
      className={className}
    >
      {phone}
    </a>
  );
};

export default SupportPhoneLink;
